import { Link } from 'react-router-dom';
import { Download, MicOff, Zap, Battery, ShieldCheck } from 'lucide-react';
import SeaCloudMuteMockup from './SeaCloudMuteMockup';

const bullets = [
  { icon: MicOff, text: 'Mute your call from your AirPods or Sony headphones' },
  { icon: Zap, text: 'Stays in sync with Google Meet automatically' },
  { icon: Battery, text: 'See battery and firmware from the menu bar' },
  { icon: ShieldCheck, text: 'No dock icon, no windows — menu bar only' },
];

export default function ProductSpotlight() {
  return (
    <section className="spotlight-section">
      <div className="section-inner spotlight-inner">
        <div className="spotlight-text">
          <span className="section-eyebrow spotlight-eyebrow">Free tool from SeaCloud Software</span>
          <h2 className="spotlight-title">SeaCloud Mute</h2>
          <p className="spotlight-desc">
            A free macOS menu bar app that lets you mute and unmute your calls straight from your
            headphones — no reaching for the trackpad mid-meeting.
          </p>

          <ul className="spotlight-bullets">
            {bullets.map((b) => {
              const Icon = b.icon;
              return (
                <li key={b.text}>
                  <span className="spotlight-bullet-icon">
                    <Icon size={15} strokeWidth={2} />
                  </span>
                  {b.text}
                </li>
              );
            })}
          </ul>

          <div className="spotlight-actions">
            <span className="spotlight-coming-soon">
              <Download size={16} strokeWidth={2} />
              Coming soon
            </span>
            <Link to="/seacloud-mute" className="spotlight-learn-more">
              See details &amp; requirements →
            </Link>
          </div>
        </div>

        <div className="spotlight-visual">
          <SeaCloudMuteMockup />
        </div>
      </div>
    </section>
  );
}
